<script>
    export default {
      mounted() {
        this.$root.botaoAcaoMostrar = false;
      }
    }
</script>

<template>
    <router-view :key="$route.path"></router-view>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/analytics/Analytics.vue